export const attendanceGroup = {
  GrupoDeEncargados: 1, // Grupo de encargados
  SegundoGrupoFirmasPostRegistro: 2, // Segundo grupo de firmas en post registro
  TercerGrupoFirmasPostRegistro: 3, // Tercer grupo de firmas en post registro
  TercerGrupoFirmasCambioImpedimentoRazonesEspecificas: 5, // Tercer grupo de firmas para cambio de impedimento por razones especificas
  SegundoGrupoFirmasCambioImpedimentoEvaluacionTrianual: 6, // Segundo grupo de firmas para cambio de impedimento por evaluación trianual
  Todos: 13, // Default todos
};
